import React from 'react';
import {
  AreaChart,
  BarChart,
  LineChart,
} from '@plerionhq/design-system/experimental';

interface ChartDataPoint {
  [key: string]: string | number;
}

interface BaseChartProps {
  data: ChartDataPoint[];
  series: string[];
  categoryKey: string;
  showLegend?: boolean;
  className?: string;
}

interface AreaChartProps extends BaseChartProps {
  type: 'area';
  seriesProps?: {
    stackId?: string;
    [key: string]: unknown;
  };
}

interface BarChartProps extends BaseChartProps {
  type: 'bar';
  seriesProps?: {
    stackId?: string;
    [key: string]: unknown;
  };
}

interface LineChartProps extends BaseChartProps {
  type: 'line';
  seriesProps?: {
    [key: string]: unknown;
  };
}

type UsageChartProps = AreaChartProps | BarChartProps | LineChartProps;

export const UsageChart: React.FC<UsageChartProps> = (props) => {
  const {
    type,
    data,
    series,
    categoryKey,
    showLegend = true,
    seriesProps = {},
    className = '',
  } = props;

  const commonProps = {
    data,
    series,
    categoryKey,
    showLegend,
    seriesProps,
    className,
    deltaConfig: {
      isNeutralStyling: true,
      showDelta: true,
    },
  };

  switch (type) {
    case 'area':
      return <AreaChart {...commonProps} />;
    case 'bar':
      return <BarChart {...commonProps} />;
    case 'line':
      return <LineChart {...commonProps} />;
    default:
      return <AreaChart {...commonProps} />;
  }
};
